<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onClickBack" />
      </template>
      キャンセル率
      <template v-slot:right>
        <a :href="faqURL">
          <FeatherIcon icon="help-circle" size="1x" class="text-gray-05 mr-2" />
        </a>
      </template>
    </Header>
    <div v-if="!isLoading">
      <div class="px-3 pt-3 pb-4">
        <BgWaveCard>
          <div class="d-flex">
            <div class="col-6 text-center">
              <div>
                <CancelPercentage
                  :percentage="cancelPercentage"
                  numberSize="10vmin"
                  unitSize="6vmin"
                  numberClass="text-weight-600"
                  unitClass="text-weight-600"
                />
              </div>
              <div class="text-mild test-weight-500 text-nowrap">
                キャンセル率
              </div>
            </div>
            <div class="col-6 text-center">
              <CancelPercentageSudden
                :percentage="suddenCancelPercentage"
                numberSize="10vmin"
                unitSize="6vmin"
                numberClass="text-weight-600"
                unitClass="text-weight-600"
              />
              <div class="text-mild test-weight-500 text-nowrap">
                直前キャンセル率
              </div>
            </div>
          </div>
          <div class="p-3"><hr /></div>
          <div>
            <span class="text-mild text-size-12">
              直前キャンセル率…直近10回の応募したお仕事のうち、お仕事開始予定時刻の24時間前を過ぎた後に、ワーカー側の都合でキャンセルされたお仕事の割合
            </span>
          </div>
        </BgWaveCard>
        <div class="canvas-wrapper position-relative"></div>
      </div>
      <div class="p-3">
        <div class="d-flex align-items-center">
          <span>応募履歴</span>
          <p class="text-size-12 text-gray-05 ml-2">
            キャンセル率に含まれる直近10件の応募履歴
          </p>
        </div>
        <div>
          <div
            v-if="!hasApplications"
            class="d-flex justify-content-center my-5"
            data-testid="work-history-does-not-exit"
          >
            勤務履歴がありません
          </div>
          <div v-else data-testid="work-history-list">
            <div
              v-for="application in applications"
              :key="application.id"
              class="mt-3"
            >
              <RouterLink
                :to="{
                  name: 'ApplicationsDetail',
                  params: { applicationId: application.id.toString() }
                }"
              >
                <ApplicationCard :application="application" />
              </RouterLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import BgWaveCard from "@/components/organisms/common/BgWaveCard.vue";
import ApplicationCard from "@/components/organisms/applications/ApplicationCard.vue";
import ApplicationsClosedList from "@/components/organisms/applications/ApplicationsClosedList.vue";
import { accountService } from "@/app/services/AccountService";
import { ErrorType, showErrorModal } from "@/utils/showErrorModal";
import CancelPercentage from "@/components/molecules/other/CancelPercentage.vue";
import CancelPercentageSudden from "@/components/molecules/other/CancelPercentageSudden.vue";
import { APP_URL_CANCEL_RATE } from "@/const/app";
import { routerPush } from "@/utils/routerPush";
import { Application } from "@/types/order/Application";

@Component({
  components: {
    FeatherIcon,
    Header,
    BgWaveCard,
    ApplicationCard,
    ApplicationsClosedList,
    CancelPercentage,
    CancelPercentageSudden
  }
})
export default class CancelRate extends Vue {
  cancelPercentage = 0;
  suddenCancelPercentage = 0;
  applications: Array<Application> = [];
  isLoading = true;

  get faqURL(): string {
    return APP_URL_CANCEL_RATE!;
  }

  get hasApplications(): boolean {
    return this.applications.length !== 0;
  }

  async fetchCancelRate() {
    const res = await accountService.fetchCancelRate();
    this.cancelPercentage = Math.floor(res.cancelRate * 100);
    this.suddenCancelPercentage = Math.floor(res.suddenCancelRate * 100);
    this.applications = res.applications;
  }

  async onClickBack() {
    await routerPush(this, { name: "Mypage" });
  }

  async created() {
    try {
      this.$loading.show();
      this.isLoading = true;
      await this.fetchCancelRate();
    } catch (error) {
      await showErrorModal(this, error as ErrorType);
    } finally {
      this.$loading.hide();
      this.isLoading = false;
    }
  }
}
</script>
